const $ = jQuery.noConflict();

$(document).ready(function () {
  $.fn.imagesLoaded = function () {

    // get all the images (excluding those with no src attribute)
    const $imgs = this.find('img[src!=""]');
    // if there's no images, just return an already resolved promise
    if (!$imgs.length) {return $.Deferred().resolve().promise();}

    // for each image, add a deferred object to the array which resolves when the image is loaded (or if loading fails)
    const dfds = [];
    $imgs.each(function (){

      const dfd = $.Deferred();
      dfds.push(dfd);
      const img = new Image();
      img.onload = function (){dfd.resolve();};
      img.onerror = function (){dfd.resolve();};
      img.src = this.src;
    });

    // return a master promise object which will resolve when all the deferred objects have resolved
    // IE - when all the images are loaded
    return $.when.apply($, dfds);
  };

  $('#social-blade').imagesLoaded().then(function () {

    if ($(window).width() < 960) {
      $('.social-block').slice(0, 4).show();
    }
    else {
      $('.social-block').slice(0, 8).show();
    }
    $('#load-more').on('click', function (e) {
      e.preventDefault();
      $('.social-block:hidden').slice(0, 4).show();
      $('.social-tile-container').masonry();
      if ($('.social-block:hidden').length === 0) {
        $('#load-more').css('display', 'none');
      }
    });

    $('.social-tile-container').masonry({
      // options
      itemSelector: '.social-block',
      columnWidth: '.social-block',
      gutter: 24,
    });
  });
});
